<template>
  <div>
    <div class='top'>检查人员信息填写</div>
    <van-cell-group>
      <van-field v-model="name" required clearable label="姓名" placeholder="请输入姓名" />
      <van-field v-model="idCard" clearable label="身份证号" :formatter="formatter" placeholder="请输入身份证号" />
      <van-field v-model="code" clearable label="学籍号" placeholder="请输入学籍号" />
      <van-field v-model="phone" type="number" clearable label="手机号" placeholder="请输入手机号" />
	  <div class="query-tip">
		  <div class="tip-row"><div class="tip-row-left">*</div> <div>身份证号码，学籍号与手机号码须至少填写一项</div></div>
		  <div class="tip-row"><div class="tip-row-left">*</div> <div>如果查询结果为空，可能以上信息未在系统登记，</div></div>
		  <div class="tip-row"><div class="tip-row-left"></div> <div>请用扫码方式查询</div></div>
	  </div>
      <van-button type="info" @click="goQuery" class="btn">
        确定
      </van-button>

      <div v-if="showAccountTitle" class="ali-title">{{ accountTitle }}</div>
    </van-cell-group>
  </div>
</template>
<script>
export default {
  name: 'query',
  data() {
    return {
      showAccountTitle: false,
      isWst: false,
      name: '',
      idCard: '',
      code: '',
      phone: '',
      openId: '',
      accountTitle: '',
      wstToken: '',
      isAgree: '',
      fromPage: 0,
    };
  },
  mounted() {
    /* this.wstToken = this.$route.query.wstToken;
    if(this.wstToken!=null && this.wstToken!=''){
      this.isWst = true;
      this.getWstInfo();
    } */
    this.openId = this.$route.query.openId;
    this.accountId = this.$route.query.accountId;
    this.isAgree = this.$route.query.isAgree;
    this.fromPage = this.$route.query.fromPage;
    console.log("fromPage="+this.fromPage)
    this.getTitle();
  },
  methods: {
    formatter(value) {
      // 过滤输入的数字
      return value.replace(/x/g, 'X');
    },
    async getWstInfo() {
      let auth = this.$createAuth(this.$md5);
      let data = {
        token: this.wstToken,
        auth: auth.code,
        time: auth.time
      };
      let result = await this.$http.get(this.$url.queryWstUser, data);
      let info = result.data.data;
      this.name = info["perUserVo.name"];
      this.idCard = info["perUserVo.credentNo"];
      this.phone = info["perUserVo.bindPhone"];
    },
    async getTitle() {
      let auth = this.$createAuth(this.$md5);
      let data = {
        openId: this.openId,
        auth: auth.code,
        time: auth.time
      };
      if (this.accountId != null && this.accountId != '') {
        data.accountId = this.accountId;
      }
      let result = await this.$http.get(this.$url.getTitle, data);
      if (result.message === 'Error: Miss auth parameter.') {
        this.getTitle();
      } else {
        document.title = result.data.title;
      }
      if (result.data.accountTitle != null && result.data.accountTitle != "") {
        this.accountTitle = result.data.accountTitle;
        this.showAccountTitle = true;
      }
      if (this.wstToken != null && this.wstToken != '') {
        document.title = '眼健康在线';
      }
    },
	async validateIDCard(idCard) {
	  let yz1 = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/.test(this.idCard);
	  let yz2 = /(^[a-zA-Z][0-9]{9})|(^[A-Z][0-9]{8})|(^[A-Z][0-9]{6}[(（][0-9a-zA-z][)）])$/.test(this.idCard);
	  if (!yz1 && !yz2) {
	    return false;
	  }
	  return true;
	},
		
	/**
	 * 验证港澳居民来往内地通行证
	 * @param {string} card 通行证号码
	 * @returns {boolean} 是否有效
	 */
	async validateHKMacaoPass(card) {
	  // 香港：1-2位字母+6-10位数字，最后一位数字或字母
	  // 澳门：数字1/5/7开头+6位数字+1位数字或字母
	  const reg = /^([A-Z]{1,2}\d{6,10}[0-9A-Z])|([157]\d{6}[0-9A-Z])$/;
	  return reg.test(card.toUpperCase());
	},
		
	/**
	 * 验证台湾居民来往大陆通行证
	 * @param {string} card 通行证号码
	 * @returns {boolean} 是否有效
	 */
	async validateTaiwanPass(card) {
	  // 8位数字或字母开头+8位数字
	  const reg = /-9A-Z]{8}\d{8}$/;
	  return reg.test(card.toUpperCase());
	},
	async validatePassport(passport) {
	    // 普通护照：E/P/D/S开头+8位数字
	    // 外交护照：DE/SE开头+7位数字
	    const reg = /EPDS]\d{8}$|DS]E\d{7}$/;
	    return reg.test(passport.toUpperCase());
	}, 
    async goQuery() {
      let auth = this.$createAuth(this.$md5);
      if (this.name == "") {
        this.$toast("请填写姓名！");
        return;
      } else {
      }
      if (this.idCard == "" && this.phone == "" && this.code == "") {
        this.$toast("身份证号码,学籍号与手机号码须至少填写一项！");
        return;
      }

      if (this.idCard != "") {
        if (!this.validateIDCard(this.idCard) && !this.validateHKMacaoPass(this.idCard) 
		&& !this.validateTaiwanPass(this.idCard) && !this.validatePassport(this.idCard)) {
          this.$toast("身份证号填写错误！");
          return;
        }
      }
      if (this.phone != "") {
        let testPhone = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[0123456789]|18[0-9]|14[57]|19[0-9])[0-9]{8}$/.test(this.phone)
        if (!testPhone) {
          this.$toast("手机号填写错误！");
          return;
        }
      }
      let result = await this.$http.post(this.$url.queryList, {
        auth: auth.code,
        time: auth.time,
        code: this.code,
        isContract: this.isAgree? 1:'',
        openId: this.openId, name: this.name, idCard: this.idCard, phone: this.phone, hospitalId: ''
      });
      if (result.message === 'Error: Miss auth parameter.') {
        this.getTitle();
      } else {
        if (result.data == null || result.data == "" || result.data.studentIds == null) {
          this.$toast(result.message);
        } else {
          console.log("fromPage2="+this.fromPage)
          if (this.isAgree) {
            this.$toast(result.message);
          } else if (this.fromPage && this.fromPage == 1){
            this.$router.push(`/questionnaire?openId=${this.$route.query.openId}`);
          } else {
            this.$router.push(`/uniapp/user?openId=${this.$route.query.openId}&pageType=1`);
          }
          /*let ids = result.data.studentIds;
          let id = (ids.split(","))[0];
          let result2 = await this.$http.get(this.$url.checkList,{
            openId:this.openId, studentId: id,
            auth: this.$pauth,
            time: this.$ptime
          });
          let list = result2.data.chekList;
          let item = list[0]
          let hospitalId = item.hospitalId;
          if(hospitalId==null || typeof(hospitalId)==undefined) hospitalId='';
          let sid = item.uid;
          /* if(list.length==1){
            let item = list[0]
            let hospitalId = item.hospitalId;
            if(hospitalId==null || typeof(hospitalId)==undefined) hospitalId='';
            let sid = item.uid;
            let activityId = item.activityId
            if (typeof(activityId) == "undefined") activityId=''
            this.$router.push(`/detail?sid=${sid}&screenType=${item.screenType}&activityId=${activityId}&openId=${this.$route.query.openId}&hospitalId=${hospitalId}&tuid=${item.studentId}`);
          }else{*/
          /*this.$router.push(`/record?sid=${sid}&openId=${this.$route.query.openId}&hospitalId=${this.$route.query.hospitalId}`);*/
          //}
        }
      }
    },
  }
};
</script>
<style scope lang="less">
.top {
  padding: 0.3rem;
  font-size: 0.32rem;
  font-weight: bold;
  border-bottom: 1px solid #dddddd;
}

.btn {
  width: 5rem;
  font-size: 0.32rem;
  margin-top: 1rem;
  border: none;
  background: #5CC4AB;
}

.query-tip {
  padding: 0.3rem 0.2rem;
  padding-right: 0.1rem;
  text-align: left;
  color: #888;
}

.tip-row{
	display: flex;
	flex-direction: row;
}

.tip-row-left{
	margin-top:0.4em;
	min-width: 0.5em;
}

.ali-title {
  position: fixed;
  bottom: 0.5rem;
  left: 0;
  margin: 0.3rem;
  text-align: left;
  line-height: 1.5em;
}

.no-result {
  width: 6.6rem;
  margin: 0.3rem auto;
  line-height: 1.5em;
}
</style>
